import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="top-center"
      offset={80}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-gradient-to-r group-[.toaster]:from-primary/90 group-[.toaster]:to-orange-500/90 group-[.toaster]:backdrop-blur-md group-[.toaster]:text-white group-[.toaster]:border-none group-[.toaster]:shadow-[0_0_30px_rgba(255,106,0,0.5)] group-[.toaster]:rounded-full px-6 py-4 font-display font-black uppercase tracking-widest text-center mx-auto justify-center animate-in zoom-in-90 slide-in-from-top-10 duration-500",
          description: "group-[.toast]:text-white/80 font-medium text-xs",
          actionButton: "group-[.toast]:bg-white group-[.toast]:text-primary rounded-full px-4 py-1 font-bold",
          cancelButton: "group-[.toast]:bg-black/20 group-[.toast]:text-white rounded-full px-4 py-1",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
